import { createBooking as publicCreateBooking, bulkCreateBooking as publicBulkCreateBooking, rescheduleBooking as publicRescheduleBooking, confirmBooking as publicConfirmBooking, updateExtendedFields as publicUpdateExtendedFields, declineBooking as publicDeclineBooking, cancelBooking as publicCancelBooking, updateNumberOfParticipants as publicUpdateNumberOfParticipants, confirmOrDeclineBooking as publicConfirmOrDeclineBooking, } from './bookings-v2-booking-bookings.public';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { onBookingCreated as publicOnBookingCreated } from './bookings-v2-booking-bookings.public';
import { onBookingRescheduled as publicOnBookingRescheduled } from './bookings-v2-booking-bookings.public';
import { onBookingCanceled as publicOnBookingCanceled } from './bookings-v2-booking-bookings.public';
import { onBookingUpdated as publicOnBookingUpdated } from './bookings-v2-booking-bookings.public';
import { onBookingConfirmed as publicOnBookingConfirmed } from './bookings-v2-booking-bookings.public';
import { onBookingDeclined as publicOnBookingDeclined } from './bookings-v2-booking-bookings.public';
import { onBookingNumberOfParticipantsUpdated as publicOnBookingNumberOfParticipantsUpdated } from './bookings-v2-booking-bookings.public';
export const createBooking = createRESTModule(publicCreateBooking);
export const bulkCreateBooking = createRESTModule(publicBulkCreateBooking);
export const rescheduleBooking = createRESTModule(publicRescheduleBooking);
export const confirmBooking = createRESTModule(publicConfirmBooking);
export const updateExtendedFields = createRESTModule(publicUpdateExtendedFields);
export const declineBooking = createRESTModule(publicDeclineBooking);
export const cancelBooking = createRESTModule(publicCancelBooking);
export const updateNumberOfParticipants = createRESTModule(publicUpdateNumberOfParticipants);
export const confirmOrDeclineBooking = createRESTModule(publicConfirmOrDeclineBooking);
export { publicOnBookingCreated };
/**
 * Triggered when a booking is created.
 */
export const onBookingCreated = createEventModule(publicOnBookingCreated);
export { publicOnBookingRescheduled };
/**
 * Triggered when a booking is rescheduled.
 */
export const onBookingRescheduled = createEventModule(publicOnBookingRescheduled);
export { publicOnBookingCanceled };
/**
 * Triggered when a booking is canceled.
 */
export const onBookingCanceled = createEventModule(publicOnBookingCanceled);
export { publicOnBookingUpdated };
/** */
export const onBookingUpdated = createEventModule(publicOnBookingUpdated);
export { publicOnBookingConfirmed };
/**
 * Triggered when a booking is confirmed.
 */
export const onBookingConfirmed = createEventModule(publicOnBookingConfirmed);
export { publicOnBookingDeclined };
/**
 * Triggered when a booking is declined.
 */
export const onBookingDeclined = createEventModule(publicOnBookingDeclined);
export { publicOnBookingNumberOfParticipantsUpdated };
/**
 * Triggered when the number of participants is updated.
 */
export const onBookingNumberOfParticipantsUpdated = createEventModule(publicOnBookingNumberOfParticipantsUpdated);
export { MultiServiceBookingType, LocationType, ValueType, BookingStatus, PaymentStatus, SelectedPaymentOption, Platform, Actor, IdentificationDataIdentityType, LocationLocationType, IdentityType, WebhookIdentityType, SortOrder, } from './bookings-v2-booking-bookings.universal';
//# sourceMappingURL=bookings-v2-booking-bookings.context.js.map